import axios from 'axios';

export const CATEGORIES_RECEIVED = 'CATEGORIES_RECEIVED';
export const DATA_GROUPS_RECEIVED = 'DATA_GROUPS_RECEIVED';
export const PRICING_RECEIVED = 'PRICING_RECEIVED';

const getProductMeta = () => (
  dispatch => (
    axios.get(`/api/product-meta`)
      .then((response) => {
        dispatch({
          type: CATEGORIES_RECEIVED,
          all: response.data.categories,
        });

        dispatch({
          type: DATA_GROUPS_RECEIVED,
          all: response.data.data_groups,
        });

        dispatch({
          type: PRICING_RECEIVED,
          all: response.data.pricing,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default getProductMeta;
